import { Box} from "@chakra-ui/react";
import PrivateContentLayout from "../Common/PrivateContentLayout";
import ChangePassword from "../Common/ChangePassword";
import AdminSideBar from "../Components/AdminSideBar";


interface ChangePasswordProps {
  handleLogout: () => void; // Pass the handleLogout function as a prop
}

const ChangePasswordAdmin = ({ handleLogout }: ChangePasswordProps) => {
  
  return (
   
    <Box>
        <AdminSideBar />
        <PrivateContentLayout>
        <ChangePassword handleLogout={handleLogout} />
        </PrivateContentLayout>
    </Box>
  );
};

export default ChangePasswordAdmin;
